import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/contentDefinitions/getDefaultFilters';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { GroupContentType } from '~src/ts/models/ContentTypes';

import { ConnectedApplications } from '../resources/ConnectedApplicationsResource';


export const ConnectedApplicationDefinition: ExplorableItemDefinition & SpaceDefinition<'connectedApplication'>  = {
  headerIconPath: () => '', // No page should be making use of this
  contentType: 'connectedApplication',
  itemType: 'connectedApplication',
  singularName: () => Messages.connectedApplication(),
  pluralName: () => Messages.connectedApplications(),
  emptyStateMessage: () => Messages.connectedApplicationsEmptyMessage(),
  contentSpaceUrl: (urls: SpacesSiteUrls, id: string) => urls.connectedApplicationUrl(id),
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null, // No page should be making use of this
  filterClause: ServerFilterClauses.ContentType(['connectedApplication']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return ConnectedApplications.all();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
